import { useMemo } from 'react';

import { useSessionData, useSessionDataWithRovoExperiment } from '@confluence/session-data';
import { useLoomEntryPointVariant } from '@confluence/loom-utils';
import { useIsCurrentPageLive } from '@confluence/live-pages-utils/entry-points/useIsCurrentPageLive';

export const useIsEligibleForLoomAIScriptSection = (
	contentNode: any,
	isEnabled?: boolean,
	readTime?: number | null,
) => {
	const isLivePage = useIsCurrentPageLive();
	const { userId } = useSessionData();
	const { entryPointVariant } = useLoomEntryPointVariant();
	const { isRovoEnabled } = useSessionDataWithRovoExperiment();

	const minimumReadTimeMet = readTime && readTime >= 7;

	return useMemo(() => {
		if (!isEnabled || !contentNode || !minimumReadTimeMet || !isRovoEnabled) {
			return false;
		}
		const contentType = contentNode?.type;
		const isContentCreator =
			'accountId' in (contentNode?.history?.createdBy ?? {}) &&
			contentNode?.history?.createdBy?.accountId === userId;

		const canEdit = contentNode?.operations?.some(
			(op) => op?.operation === 'update' && op?.targetType === contentType,
		);

		return (
			isContentCreator &&
			contentType === 'page' &&
			(entryPointVariant === 'CO_USE' ||
				entryPointVariant === 'CROSS_FLOW' ||
				entryPointVariant === 'CROSS_JOIN') &&
			canEdit &&
			!isLivePage
		);
	}, [
		isEnabled,
		contentNode,
		userId,
		entryPointVariant,
		isLivePage,
		minimumReadTimeMet,
		isRovoEnabled,
	]);
};
